/** Categorías de documentos de normatividad (slug guardado en BD). */
export const NORMATIVIDAD_CATEGORIES = [
  {
    id: 'asamblea',
    label: 'Documentos de asamblea',
    description: 'Actas, convocatorias y documentos derivados de las asambleas de asociados.',
  },
  {
    id: 'reglamentos',
    label: 'Reglamentos de la institución',
    description: 'Estatutos, reglamentos internos y lineamientos oficiales de la cooperativa.',
  },
  {
    id: 'registro-rte-dian',
    label: 'Registro Web Actualización RTE DIAN',
    description: 'Documentos del registro web de actualización RTE ante la DIAN.',
  },
];

export const NORMATIVIDAD_CATEGORY_IDS = NORMATIVIDAD_CATEGORIES.map((c) => c.id);

export function getNormatividadCategoryLabel(id) {
  return NORMATIVIDAD_CATEGORIES.find((c) => c.id === id)?.label ?? id;
}

export function groupNormatividadByCategory(items) {
  return NORMATIVIDAD_CATEGORIES.map((cat) => ({
    ...cat,
    documentos: (items ?? []).filter((doc) => doc.categoria === cat.id),
  })).filter((section) => section.documentos.length > 0);
}
